import { cn } from '@/utils/ui/styles'

import { Skeleton } from '../ui/skeleton'

type TableSkeletonProps = {
	rows?: number
	className?: string
}

/**
 * Suspense fallback for table views: a stack of `rows` (default 24) full-width
 * row skeletons.
 */
export const TableSkeleton = ({ rows = 24, className }: TableSkeletonProps) => {
	return (
		<div
			className={cn(
				'flex h-full w-full flex-col items-start justify-start gap-2',
				className,
			)}
		>
			{Array.from({ length: rows }).map((_, i) => (
				<Skeleton key={i} className="h-12 w-full" />
			))}
		</div>
	)
}
